
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import ShopCard from "./components/ShopCardView.vue"; // @ is an alias to /src
import HomePartActivitiesView from "./HomePart/HomePartActivitiesView.vue"; // @ is an alias to /src

import {
    getCarouseImg,
    getProductList,
    getProductClassify,
} from "../../api/shopApi";

import { getByCode } from '@/api/AppsettingsApi';
import runEvn from "../../modular/runEvn/RunEvn";
import { keepDecimal } from "@/modular/Number";

const fileBaseUrl = runEvn().fileBaseUrl;

const evn = runEvn().evn;

// import 'swiper/swiper.scss';

export default defineComponent({
    name: "Home",
    mounted() {
        this.LoadData();
        this.handleData();
        this.timer = setInterval(async () => {
            const index = Math.floor(Math.random() * 2);
            const arr = ["送货上门", "上门服务"];
            this.searchVal = arr[index];
        }, 2000);
    },
    setup() {
        const router = useRouter();
        return {
            freeShippingTips: process.env.VUE_APP_FREE_SHIPPING_TIPS,
            router, //一定要要放在return里才能在模板上面使用
            viewShopHomeTipsHide: runEvn().viewShopHomeTipsHide,
            aaa: new Date().getSeconds()
        };
    },
    components: {
        ShopCard,
        HomePartActivitiesView,
    },
    data() {
        return {
            searchVal: "",
            tagList: [],
            middleNavData: [
                {
                    id: "1",
                    classifyName: "送货上门",
                    img: require("@/assets/image/icon_product.png"),
                },
                {
                    id: "2",
                    classifyName: "上门服务",
                    img: require("@/assets/image/icon_service.png"),
                },
                {
                    id: "3",
                    classifyName: "限时秒杀",
                    img: require("@/assets/image/icon_seckill.png"),
                },
                {
                    id: "4",
                    classifyName: "特惠拼团",
                    img: require("@/assets/image/icon_group.png"),
                },
            ],
            timer: 0,
            carouseImgs: [], ///轮播图
            productList: [], //商品列表
            serviceList: [], //服务列表

            showGYLink: false,//是否显示公益池
        };
    },
    deactivated() {
        this.clearTimer();
    },
    methods: {
        keepDecimal(numStr: number, x: number) {
            return keepDecimal(numStr, x);
        },
        clearTimer() {
            clearInterval(this.timer);
        },
        middleNavClick(item: any): void {
            if (item.id == 1 || item.id == 2) {
                this.router.push({
                    path: `/shop/goods/home`,
                    query: {
                        productType: item.id,
                    },
                });
            } else if (item.id == 3 || item.id == 4) {
                const type = item.id == 3 ? 1 : 2;
                const path = type == 1 ? "seckill" : "group";
                this.router.push({
                    path: `/shop/goods/discountsList/${path}`,
                    query: {
                        type: type,
                    },
                });
            } else {
                this.router.push({
                    path: `/shop/goods/home`,
                    query: {
                        id: item.id,
                        productType: item.productType,
                    },
                });
            }
        },
        goImgurl(url: string) {
            if (url != null && url != "") location.href = url;
        },
        toList(type: string) {
            const path = type == "1" ? "seckill" : "group";
            this.router.push({
                path: `/shop/goods/discountsList/${path}`,
                query: {
                    type: type,
                },
            });
        },
        goList(type: number) {
            this.router.push({
                path: `/shop/goods/home`,
                query: {
                    productType: type,
                },
            });
        },
        goSearch() {
            if (this.searchVal == "送货上门") {
                this.goList(1);
            } else {
                this.goList(2);
            }
        },
        async LoadData() {
            // const LumpList = await getHomePageActivitiesProduct(
            //     Object.assign(params, {
            //         campaignType: 2,
            //     })
            // );
            // const seckillList = await getHomePageActivitiesProduct(
            //     Object.assign(params, {
            //         campaignType: 1,
            //     })
            // );
            // this.LumpList = LumpList.products;
            // this.seckillList = seckillList.products;
            // this.$set(this,'seckillList',seckillList.products)
            // console.log(seckillList.products);
            var datas = (await getCarouseImg(1, 3)) as any;
            this.carouseImgs = datas.rows;
            var list = (await getProductList(1, 1, 4, "")) as any;
            this.productList = list.rows;
            var listService = (await getProductList(2, 1, 4, "")) as any;
            this.serviceList = listService.rows;

            this.showGYLinkFun();
        },
        async handleData() {
            let index = 0;
            this.tagList[index] = [];
            let loadDataSize = 16;
            if (evn == "shanchen") {
                this.middleNavData = [];
                loadDataSize = 20;
            }
            let list = (await getProductClassify(loadDataSize)) as any;

            this.middleNavData.push(...list);
            this.middleNavData.forEach((item) => {
                if (this.tagList[index].length > 9) {
                    index++;
                    this.tagList[index] = [];
                }
                this.tagList[index].push(item);
            });
        },
        img(key: string) {
            return fileBaseUrl + key;
        },

        async showGYLinkFun() {
            const data: any = await getByCode('showGYLink') || {};
            if (data) {
                if (data.val == 'true') {
                    this.showGYLink = true;
                } else {
                    this.showGYLink = false;
                }
            }
        }
    },
});
